import React, { useMemo } from 'react'
import cx from 'classnames'
import { Loader } from '../..'
import styles from './ListingTemplate.module.scss'
interface ListingTemplateProps {
  loading?: boolean
  Header?: React.ReactNode
  Body?: React.ReactNode
  Footer?: React.ReactNode
}

const ListingTemplate = ({ loading, Header, Body, Footer }: ListingTemplateProps) => {
  const bodyClasses = useMemo(
    () =>
      cx(styles.body, {
        [styles.loading]: loading,
      }),
    [loading],
  )

  return (
    <div className={styles.root}>
      {Header && <div className={styles.header}>{Header}</div>}
      {Body && <div className={bodyClasses}>{loading ? <Loader /> : Body}</div>}
      {Footer && <div className={styles.footer}>{Footer}</div>}
    </div>
  )
}

export default ListingTemplate
